import React from 'react';
import { useSelector } from 'react-redux';
import styles from './index.module.scss';
import PostTitleV1 from '../../../text_components/post_title_v1';
import UnknownText from '../../../text_components/unknown_text';
import PostDescriptionV1 from '../../../long_text_components/post_description_v1';
import UnknownLongText from '../../../long_text_components/unknown_long_text';
import PostImageV1 from '../../../img_components/post_image_v1';
import GalleryComponent from '../../../imgs_block_components/gallery_component';
import UnknownImgsBlock from '../../../imgs_block_components/unknown_imgs_block';
import VideoComponent from '../../../video_components/video_component';
import UnknownVideo from '../../../video_components/unknown_video';
import { apiHost } from '../../../../../axios/axios_settings';

const PostBlock = ({
  blockData,
  path_to_folder,
  globalIndex = undefined,
}) => {
  void globalIndex;
  const authorCardsMeta = useSelector((state) => state.others_data?.author_cards_meta || []);

  const renderContent = (content) => {
    if (content.cotent_type === 'text' || content.content_type === 'text') {
      switch (content.cotent_tag || content.content_tag) {
        case 'title':
          return (
            <PostTitleV1
              contentText={content.content_text}
              contentTag={content.cotent_tag || content.content_tag}
              contentName={content.cotent_name || content.content_name}
            />
          );
        default:
          return (
            <UnknownText
              contentText={content.content_text}
              contentTag={content.cotent_tag || content.content_tag}
              contentName={content.cotent_name || content.content_name}
            />
          );
      }
    }

    if (content.cotent_type === 'long_text' || content.content_type === 'long_text') {
      switch (content.cotent_tag || content.content_tag) {
        case 'description':
          return (
            <PostDescriptionV1
              contentText={content.content_text}
              contentTag={content.cotent_tag || content.content_tag}
              contentName={content.cotent_name || content.content_name}
            />
          );
        default:
          return (
            <UnknownLongText
              contentText={content.content_text}
              contentTag={content.cotent_tag || content.content_tag}
              contentName={content.cotent_name || content.content_name}
            />
          );
      }
    }

    if (content.cotent_type === 'img' || content.content_type === 'img') {
      return (
        <PostImageV1
          contentData={content}
          contentName={content.cotent_name || content.content_name}
          path_to_folder={path_to_folder}
        />
      );
    }

    if (content.cotent_type === 'imgs_block' || content.content_type === 'imgs_block') {
      switch (content.cotent_tag || content.content_tag) {
        case 'gallery':
          return (
            <GalleryComponent
              contentData={content}
              contentName={content.cotent_name || content.content_name}
              path_to_folder={path_to_folder}
            />
          );
        default:
          return (
            <UnknownImgsBlock
              contentData={content}
              contentName={content.cotent_name || content.content_name}
              path_to_folder={path_to_folder}
            />
          );
      }
    }

    if (content.cotent_type === 'video' || content.content_type === 'video') {
      switch (content.cotent_tag || content.content_tag) {
        case 'main_video':
          return (
            <VideoComponent
              contentData={content}
              contentName={content.cotent_name || content.content_name}
              path_to_folder={path_to_folder}
            />
          );
        default:
          return (
            <UnknownVideo
              contentData={content}
              contentName={content.cotent_name || content.content_name}
              path_to_folder={path_to_folder}
            />
          );
      }
    }

    return null;
  };

  if (!blockData || !blockData.block_content || !Array.isArray(blockData.block_content)) {
    return null;
  }

  const imageContent = blockData.block_content.filter((content) => content.cotent_type === 'img' || content.content_type === 'img');
  const titleContent = blockData.block_content.filter(
    (content) => (content.cotent_type === 'text' || content.content_type === 'text') && (content.cotent_tag === 'title' || content.content_tag === 'title'),
  );
  // Текст описания берём из content_text элемента с картинкой (img), а не из long_text
  const descriptionTextFromImages = imageContent
    .map((content) => content.content_text)
    .filter((text) => text && text !== 'none' && String(text).trim() !== '');
  const otherContent = blockData.block_content.filter(
    (content) =>
      (content.cotent_type !== 'img' && content.content_type !== 'img') &&
      !((content.cotent_type === 'text' || content.content_type === 'text') && (content.cotent_tag === 'title' || content.content_tag === 'title')) &&
      !((content.cotent_type === 'long_text' || content.content_type === 'long_text') && (content.cotent_tag === 'description' || content.content_tag === 'description')) &&
      !((content.cotent_type === 'text' || content.content_type === 'text') && (content.cotent_tag === 'authors' || content.content_tag === 'authors')),
  );

  const normalizedAuthorEngNames = (() => {
    const authorsBlock = blockData.block_content.find((content) => {
      const type = (content?.cotent_type || content?.content_type || '').toLowerCase();
      const tag = (content?.cotent_tag || content?.content_tag || '').toLowerCase();
      return type === 'text' && tag === 'authors';
    });

    const authorsRaw = typeof authorsBlock?.content_text === 'string' ? authorsBlock.content_text : '';
    return authorsRaw
      .split(',')
      .map((name) => name.trim().toLowerCase())
      .filter((name) => name && name.toLowerCase() !== 'none');
  })();

  const authorAvatars = normalizedAuthorEngNames
    .map((engName) => {
      const matched = authorCardsMeta.find(
        (item) => String(item?.eng_name || '').trim().toLowerCase() === engName,
      );
      if (!matched?.avatar_path) return null;
      return {
        eng_name: matched.eng_name || engName,
        avatar_path: matched.avatar_path,
        author_name: matched.author_name || engName,
      };
    })
    .filter(Boolean);

  const handleAuthorAvatarClick = (authorEngName) => {
    if (!authorEngName) return;
    const normalizedTargetEngName = String(authorEngName).trim().toLowerCase();
    const authorCardElement = Array.from(document.querySelectorAll('[data-eng-name]')).find(
      (el) =>
        String(el.getAttribute('data-eng-name') || '')
          .trim()
          .toLowerCase() === normalizedTargetEngName,
    );
    if (!authorCardElement) return;

    const header = document.querySelector('header');
    const headerOffset = (header?.offsetHeight || 60) + 16;
    const targetY = authorCardElement.getBoundingClientRect().top + window.scrollY - headerOffset;

    window.scrollTo({
      top: Math.max(targetY, 0),
      behavior: 'smooth',
    });
  };

  const rawAuthorsText = (() => {
    const authorsBlock = blockData.block_content.find((content) => {
      const type = (content?.cotent_type || content?.content_type || '').toLowerCase();
      const tag = (content?.cotent_tag || content?.content_tag || '').toLowerCase();
      return type === 'text' && tag === 'authors';
    });
    return typeof authorsBlock?.content_text === 'string' ? authorsBlock.content_text : '';
  })();

  console.log('[post_block][authors_render_check]', {
    rawAuthorsText,
    normalizedAuthorEngNames,
    reduxAuthorEngNames: authorCardsMeta.map((item) => item?.eng_name).filter(Boolean),
    matchedAuthorAvatars: authorAvatars,
  });

  const downloadFileName = (() => {
    const downloadBlock = blockData.block_content.find((content) => {
      const tag = content?.cotent_tag || content?.content_tag;
      return tag === 'file_name_for_download';
    });

    const rawName = typeof downloadBlock?.content_text === 'string' ? downloadBlock.content_text.trim() : '';
    if (!rawName || rawName.toLowerCase() === 'none') return '';
    return rawName;
  })();

  const handleDownload = async () => {
    if (!downloadFileName) return;

    const encodedFileName = encodeURIComponent(downloadFileName);
    const fileUrl = `https://${apiHost}/adminka_project/downloaded_files/${encodedFileName}`;
    console.log('[post_block][download_click_url]', { downloadFileName, encodedFileName, fileUrl });

    try {
      const response = await fetch(fileUrl, {
        method: 'GET',
        cache: 'no-store',
      });
      if (!response.ok) {
        alert('Файл не найден или недоступен для скачивания.');
        return;
      }

      const contentType = (response.headers.get('content-type') || '').toLowerCase();
      const contentDisposition = response.headers.get('content-disposition') || '';

      // Если сервер вернул HTML (например, страницу ошибки), не пытаемся сохранять это как файл.
      if (contentType.includes('text/html')) {
        alert('Сервер вернул страницу вместо файла. Проверьте имя файла и доступность на сервере.');
        return;
      }

      const sourceBlob = await response.blob();

      // Частый кейс: сервер возвращает небольшой текст ошибки вместо файла.
      if (sourceBlob.size > 0 && sourceBlob.size <= 2048 && !contentDisposition.toLowerCase().includes('attachment')) {
        const previewText = (await sourceBlob.text()).trim();
        const looksLikeTextError =
          contentType.includes('text/') ||
          contentType.includes('json') ||
          previewText.startsWith('<!doctype') ||
          previewText.startsWith('<html') ||
          previewText.toLowerCase().includes('error') ||
          previewText.toLowerCase().includes('not found');

        if (looksLikeTextError) {
          alert('Сервер вернул текст/ошибку вместо файла. Проверьте имя файла и его наличие на сервере.');
          return;
        }
      }

      const fileNameFromDisposition =
        contentDisposition.match(/filename\*=UTF-8''([^;]+)/i)?.[1] ||
        contentDisposition.match(/filename="?([^"]+)"?/i)?.[1] ||
        '';
      const finalDownloadName = decodeURIComponent(fileNameFromDisposition || downloadFileName);

      const blobUrl = window.URL.createObjectURL(sourceBlob);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = finalDownloadName;
      link.target = '_self';
      link.rel = 'noopener noreferrer';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      alert('Не удалось скачать файл. Проверьте подключение к интернету.');
    }
  };

  return (
    <div className={styles.postBlock}>
      <div className={styles.contentContainer}>
        <div className={styles.textContentWrapper}>
          <div className={styles.titleSection}>
            <div className={styles.titleAndFiltersContainer}>
              <div className={styles.titleContent}>
                {titleContent.map((content, index) => (
                  <div key={`title-${index}`} className={styles.titleWrapper}>
                    {renderContent(content)}
                  </div>
                ))}
              </div>
              {authorAvatars.length > 0 && (
                <div className={styles.authorsSection}>
                  <span className={styles.authorsTitle}>
                    {authorAvatars.length === 1 ? 'Автор проекта' : 'Авторы проекта'}
                  </span>
                  <div className={styles.authorsList}>
                    {authorAvatars.map((author) => (
                    <button
                      type='button'
                      key={author.eng_name}
                      className={styles.authorAvatarWrap}
                      title={author.author_name}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleAuthorAvatarClick(author.eng_name);
                      }}>
                        <img
                          src={author.avatar_path}
                          alt={author.author_name}
                          className={styles.authorAvatar}
                        />
                    </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {imageContent.map((content, index) => (
          <div key={`img-${index}`} className={styles.imageWrapper}>
            {renderContent(content)}
          </div>
        ))}

        <div className={styles.textContentWrapper}>
          <div className={styles.descriptionSection}>
            {descriptionTextFromImages.map((contentText, index) => (
              <div key={`description-img-${index}`} className={styles.contentWrapper}>
                <PostDescriptionV1 contentText={contentText} contentTag='description' contentName='' />
              </div>
            ))}
            {otherContent.map((content, index) => (
              <div key={`other-${index}`} className={styles.contentWrapper}>
                {renderContent(content)}
              </div>
            ))}
            {downloadFileName && (
              <button type='button' className={styles.downloadButton} onClick={handleDownload}>
                Скачать
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PostBlock;
